export default __webpack_public_path__ + "static/media/050_brake.first.a55b32ba.webp";